import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Center from '@zenbusiness/zui/Center';
import Heading from '@zenbusiness/zui/Heading';
import PageContainer from '@zenbusiness/zui/PageContainer';
import Text from '@zenbusiness/zui/Text';

const MESSAGE_IDS = {
  subtitle: 'dashboard.enterpriseHome.noEntity.subtitle',
  title: 'dashboard.enterpriseHome.noEntity.title',
};

function NoEntity() {
  return (
    <PageContainer height="100%">
      <Center gap={1}>
        <Heading align="center" component="h1" size="xl" weight="medium" wrap="wrap">
          <FormattedMessage id={MESSAGE_IDS.title} />
        </Heading>
        <Text align="center" color="secondary" component="p" size="md">
          <FormattedMessage id={MESSAGE_IDS.subtitle} />
        </Text>
      </Center>
    </PageContainer>
  );
}

export default NoEntity;
